import React from 'react';

export default function Error({ error }) {
  if (!error) return null;
  return (
    <div className="halan_error">
      <p className="halan_error_content">{error}</p>
    </div>
  );
}
